import React, { FC } from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import EmailIcon from '@mui/icons-material/Email';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PrintIcon from '@mui/icons-material/Print';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { StyledActionButton } from './styled';
import { blue } from 'themes/colors';
import { ActionButtonProps } from './types';
import { ReactComponent as DockSideIcon } from 'assets/icons/new/dock_side.svg';
import OpenInFullOutlinedIcon from '@mui/icons-material/OpenInFullOutlined';
import EditIcon from '@mui/icons-material/Edit';

const ActionButton: FC<ActionButtonProps> = ({ handleClick, type, size, color = 'blue', disabled = false }) => {
  const icons = {
    print: <PrintIcon fontSize='small' />,
    preview: <VisibilityIcon fontSize='small' />,
    hidden: <VisibilityOffIcon fontSize='small' />,
    email: <EmailIcon fontSize='small' />,
    view: <ArrowForwardIcon fontSize='small' sx={{ color: color === 'white' ? blue[400] : '#fff' }} />,
    newtab: <OpenInNewIcon fontSize='small' sx={{ color: color === 'white' ? blue[400] : '#fff' }} />,
    menu: <MoreVertIcon fontSize='small' sx={{ color: color === 'white' ? blue[400] : '#fff' }} />,
    dock: <DockSideIcon />,
    'open-in-full': (
      <OpenInFullOutlinedIcon
        fontSize='small'
        sx={{ color: color === 'white' || color === 'secondary-light' ? blue[400] : '#fff' }}
      />
    ),
    edit: (
      <EditIcon
        fontSize='small'
        sx={{ color: color === 'white' || color === 'secondary-light' ? blue[400] : '#fff' }}
      />
    ),
  };

  return (
    <div>
      <StyledActionButton
        disabled={disabled}
        data-test={`${type}-button`}
        size={size}
        buttonColor={color}
        variant='contained'
        type='button'
        onClick={handleClick}
      >
        {icons[type]}
      </StyledActionButton>
    </div>
  );
};

export default ActionButton;
